import { render, staticRenderFns } from "./listActivity.vue?vue&type=template&id=4a4c66fa&scoped=true"
import script from "./listActivity.vue?vue&type=script&lang=js"
export * from "./listActivity.vue?vue&type=script&lang=js"
import style0 from "./listActivity.vue?vue&type=style&index=0&id=4a4c66fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c66fa",
  null
  
)

export default component.exports